import React, { Fragment, useState, useContext, useEffect } from 'react';
import { CartContext } from 'components/cart';
import classNames from 'lib/classNames';



const Scary = ({scary}) => {
	const {
		Utils,
        isPreview,
        AppLocalStorage
	} = useContext(CartContext);

    const [timer, setTimer] = useState("")
    const [inter, setInter] = useState("")
    const [isTimerVisible, setIsTimerVisible] = useState(true)

    const cookieKey = 'mu_scary_1'

    useEffect(() => {
        clearInterval(inter);
        let countDownDate = new Date().getTime();

        let due = scary.days * 86400000 + scary.hours * 3600000 + scary.minutes * 60000 +scary.seconds * 1000 

        if(!isPreview && AppLocalStorage.getItem(cookieKey)){
            countDownDate = parseInt(AppLocalStorage.getItem(cookieKey))
        } else {
            countDownDate = countDownDate +  due
            AppLocalStorage.setItem(cookieKey, countDownDate);
        }

        // Update the count down every 1 second
        const x = setInterval(function() {
            setIsTimerVisible(true)
            // Get today's date and time
            const now = new Date().getTime();

            // Find the distance between now and the count down date
            const distance = countDownDate - now;
            // Time calculations for days, hours, minutes and seconds
            const days = ("0" + Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2) ;
            const hours = ("0" + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
            const minutes = ("0" + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
            const seconds =("0" + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2)  ;

            let timerString = ""
            if(scary.isDaysActive) timerString += days+':'
            if(scary.isHoursActive) timerString += hours+':'
            if(scary.isMinutesActive) timerString += minutes+':'
            if(scary.isSecondsActive) timerString += seconds+':'

            setTimer( timerString.substring(0, timerString.length - 1) )

            // If the count down is finished, restart or hide it
            if (distance < 2000) {
                if(scary.endAction === "restart"){
                    countDownDate = new Date().getTime();
                    countDownDate = countDownDate +  scary.days * 86400000 + scary.hours * 3600000 + scary.minutes * 60000 +scary.seconds * 1000 
                }else{
                    setIsTimerVisible(false)
                    clearInterval(inter);
                }
                
            }
        }, 1000);
        setInter(x)

        // to avoid intervals overlapping while typing the damn text
    },[scary.isDaysActive, scary.isHoursActive,scary.isMinutesActive,scary.isSecondsActive,scary.days,scary.hours,scary.minutes,scary.seconds])

    const textAlignement = {"left": "start", "center": "center", "right": "end"}
    return (
            isTimerVisible ?
            <div 
                className={classNames('',{
                    ['px-5']: scary.placement === "top" && scary.style == "rounded",
                    ['-mx-5']: scary.placement === "bottom" && scary.style == "full",
                    ['mb-3'] : scary.placement === "bottom" 
                })}
             >
                <div 
                    className={classNames('px-5 py-2',{["rounded"]:  scary.style == "rounded",})}
                    style={{
                        fontSize: `${scary.text.font_size}em`,
                        color: Utils.formatColor(scary.text.color),
                        background: Utils.formatColor(scary.background),
                        borderTop: `${Utils.formatColor(scary.border)} 1px solid`,
                        borderBottom: `${Utils.formatColor(scary.border)} 1px solid`,
                        borderRight:  scary.style == "rounded" && `${Utils.formatColor(scary.border)} 1px solid`,
                        borderLeft:  scary.style == "rounded" && `${Utils.formatColor(scary.border)} 1px solid`,
                        textAlign: textAlignement[scary.textAlignement]
                    }}
                >
                    <span 
                        dangerouslySetInnerHTML={{
                            __html: scary.text.text.replace(/{{timer}}/, '<b>'+timer+'</b>'),
                        }}
                    />
                </div>
            </div>
            :
            null        
    )
}


export default Scary;